import React, { useState, useEffect } from 'react'
import { Button } from 'primereact/button'
import { useHistory } from 'react-router-dom';
import { InputText } from 'primereact/inputtext'
import { MensajeAdvertencia } from '../components/mensajes/Mensajes'
import { Service } from "../service/Service";
import Logo from '../img/logoublick.png'
import { GET_TOKEN_LOGIN } from "../genericos/Uris";
import { Dialog } from 'primereact/dialog';
import Spinner from '../components/loader/Spinner';

const Login = ({ setLogueado }) => {
    let history = useHistory();
    //--------------------| Variables para iniciar sesion  |--------------------
    const [texto, setTexto] = useState('')
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [loading, setLoading] = useState(false);

    //--> Mensaje error
    const [errorGeneral, setErrorGeneral] = useState(false)
    const [errorAutenticacion, setErrorAutenticacion] = useState(false)
    const [mensajeError, setMensajeError] = useState("")

    const servicioAuth = new Service();

    const expresion = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/


    //--------------------| Funcion Autentication  |--------------------

    useEffect(() => { return () => { setLoading(false) } }, [])

    const getTokeAuth = async () => {

        let body = {
            "username": email,
            "password": password
        }
        try {

            servicioAuth.baseUrl = servicioAuth.baseUrl + GET_TOKEN_LOGIN;
            // console.log(servicioAuth.baseUrl)
            setLoading(true)
            const data = await servicioAuth.login(body)
            // console.log(data.token)
            localStorage.setItem('tokenAdmin', data.token)   // Crea valor para inicio de sesion
            setLogueado(true)                           // Iniciar sesion 
            // console.log("Inicio de sesion")
            setLoading(false)
        }
        catch (error) {
            // setMensajeError(error.message)
            if (error.message === "Request failed with status code 401") {
                // setTextoValidacion("Usuario y contraseña no validos")
                setErrorAutenticacion(true)
            }
            else {
                setMensajeError(error.message)
                setErrorGeneral(true)
            }
        }
        setLoading(false)
    }

    //--------------------| Funcion para iniciar sesion  |--------------------
    const enviarDatos = (e) => {
        e.preventDefault()
        //---> Validacion de campos vacios
        if ([email, password].includes("")) {
            setTexto("Todos los campos son obligatorios")
            setTimeout(() => {
                setTexto('')
            }, 3000);
            return
        }
        //---> Validacion de contraseña
        if (!(password.length >= 6)) {
            setTexto("Contraseña invalida")
            setTimeout(() => {
                setTexto('')
            }, 3000);
            return
        }
        //---> Envio de datos
        getTokeAuth()
    }
    //--> Funcion para recuperar password
    const recupararPassword = () => {
        setLoading(true)
        history.push("/recuperarPassword")
        setLoading(false)
    }

    const botonModalError = (<><Button label="Aceptar" onClick={() => { setErrorGeneral(false) }} /></>)
    const botonModalAutenticacion = (<><Button label="Aceptar" onClick={() => { setErrorAutenticacion(false) }} /></>)


    //--------------------| Valor que regresara  |--------------------
    return (
        <>
            {loading && (<Spinner />)}
            {!loading && (
                <div
                    className='flex justify-content-center align-items-center h-screen'
                >
                    <form onSubmit={enviarDatos} noValidate  >
                        <div>
                            <div className="card md:mx-8">
                                <div className='flex justify-content-center'>
                                    <img src={Logo} alt='logo ublick' className='w-12 md:w-6' />
                                </div>
                                <div className="flex flex-column flex-wrap align-items-center justify-content-center" >
                                    <div className="field ">
                                        <InputText
                                            id="email" type="email"
                                            className="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary min-w-min md:w-20rem"
                                            value={email} onChange={e => setEmail(e.target.value)}
                                            placeholder="Ingresa tu usuario" maxLength={100} /> 
                                    </div>
                                    <div className="field">
                                        <InputText
                                            id="password" type="password"
                                            value={password} onChange={e => setPassword(e.target.value)}
                                            placeholder="Ingresa tu contraseña" maxLength={150}
                                            className="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary min-w-min md:w-20rem"
                                        />
                                    </div>
                                    <div className="field">
                                        <Button label="Iniciar Sesión" icon="pi pi-user" className="w-auto mx-auto" />
                                    </div>
                                    <div className="field">
                                        <Button onClick={recupararPassword} className="mt-0 p-button-text" >
                                            <p className='text-xs'>¿Olvidaste tu contraseña?</p>
                                        </Button>
                                    </div>
                                    {texto && <MensajeAdvertencia>{texto}</MensajeAdvertencia>}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            )}

            <Dialog
                style={{ width: '50vw' }} footer={botonModalError}
                visible={errorGeneral} onHide={() => setErrorGeneral(false)}
            >
                <div className='card-container yellow-container overflow-hidden'>
                    <div className='bg-yellow-400 border-round border-1 border-yellow-400'>
                        <div className='font-bold text-center py-2 text-3xl'>Algo salió mal</div>
                        <div className='text-center surface-overlay border-round'>
                            <p className='text-xl'>Por favor contácte al administrador.</p>
                            <p className='text-xl'>Tipo de error: <span className='underline'>{mensajeError}</span>.</p>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog style={{ width: '50vw' }} footer={botonModalAutenticacion} visible={errorAutenticacion} onHide={() => setErrorAutenticacion(false)}>
                <div className='card-container yellow-container overflow-hidden'>
                    <div className='bg-yellow-400 border-round border-1 border-yellow-400'>
                        <div className='font-bold text-center py-2 text-3xl'>Algo salió mal</div>
                        <div className='text-center surface-overlay border-round'>
                            <p className='text-xl'>Usuario y contraseña no validos.</p>
                        </div>
                    </div>
                </div>
            </Dialog>

        </>
    )
}

export default Login
